import type { User } from 'types/session/user'
import { env } from 'utils/envManager'
import { url } from 'utils/url'

export const userDetailsUrl = (
	externalId: string | null,
	shouldRefresh: boolean
) =>
	url(
		`${env.NEXT_PUBLIC_API_DOMAIN}/ws/0/online-customer-service/customer/v1/`,
		{
			externalDetails: 'true',
			externalId: externalId ?? '',
			dc: shouldRefresh ? '0' : '15m',
		}
	)

export const userDetailsService = async (
	token: string | null,
	externalId: string | null,
	shouldRefresh = false
): Promise<User | null> => {
	let response: Response | null = null
	if (token) {
		response = await fetch(userDetailsUrl(externalId, shouldRefresh), {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			next: { revalidate: 0 },
		})

		if (response.ok) {
			return response.json()
		}
	}
	console.error(
		`[Online Customer Service - User Details] failed to fetch.\n ${response?.status}: ${response?.statusText}`
	)

	return null
}
